import React, { useState } from 'react';
import { ToastContainer, toast } from 'react-toastify';

// Modal
import DeleteCategoryModal from '../AddNewFileMainPageCards/DeleteCategoryModal';

//Styles 
import styles from "../AddNewFileMainPage/AddNewFileMainPage.module.css"
import 'react-toastify/dist/ReactToastify.css';

//images
import trashIcon from "../../../../assets/img/DashboardICons/TrashIcon.svg"

export default function CategoryCards(props) {
    const [showModal, setShowModal] = useState({
        id: "",
        open: false
    })

    return (
        <>
            <DeleteCategoryModal
                show={showModal.open}
                id={showModal.id}
                onHide={() => setShowModal((prev) => {
                    return { ...prev, open: false };
                })}
                notify={notify}
            />

            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover={false}
                theme="light"
            />

            <div className={`${props.userAdd ? "p-0" : "py-2"}`}>
                <div className={`${props.userAdd ? "p-0 container-fluid" : "container-fluid"}`}>
                    <div
                        className={`d-flex justify-content-center flex-wrap align-items-center ${props.userAdd ? "" : "mt-2 me-3"}`}
                        dir="rtl"
                    >
                        <div className='w-100 d-flex align-items-center justify-content-xl-between justify-content-center flex-wrap'>
                            {props?.categories?.map((item) => (
                                <div key={item.id} onClick={() => clickHandler(item.id, item.title)} className={`position-relative d-flex flex-column align-items-center justify-content-center my-3 pointer ${props.userAdd ? "mx-xl-1 mx-lg-0" : "mx-xl-1 mx-lg-0"} ${props.userAdd ? styles.card_container_user : styles.card_container}`}>
                                    <div className='d-flex align-items-center justify-content-center'>
                                        <img className={styles.icon} loading="lazy" src={`https://backdev.azrmelk.com/images/categoryIcon/${item.icon}`} alt="icon" />
                                        <div className={`me-2 ${styles.card_text}`}>
                                            {item.title}
                                        </div>
                                    </div>
                                    {props.permissions?.find((item) => item === 15) === 15
                                        ?
                                        <div className={`position-absolute ${styles.remove_category_container}`} onClick={(e) => {
                                            e.stopPropagation();
                                            setShowModal((prev) => {
                                                return { open: true, id: item.id };
                                            });
                                        }}>
                                            <img src={trashIcon} alt="icon" />
                                        </div>
                                        :
                                        <></>
                                    }
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div >
        </>
    )

    function clickHandler(id, title) {
        props.setShowPage((prev) => {
            return { ...prev, categoriID: id, categoriTitle: title, pageNumber: 2, subIsSelected: true };
        })
    }

    function notify(text, type) {
        if (type === "success") {
            toast.success(text, {
                position: "top-right",
                autoClose: 8000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        } else {
            toast.error(text, {
                position: "top-right",
                autoClose: 8000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        }
    };
}
